import React from 'react';
import {
   Input,
} from 'reactstrap';
import PropTypes from 'prop-types';
import withInputErrorMessage from '../withInputErrorMessage';
import withTextInput from './withTextInput';
import withUseEffectErrorMessage from './withUseEffectErrorMessage';

const TextInput = (props) => {
   return (
      <Input
         type={props.type}
         name={props.name}
         onChange={props.handleChange}
         onBlur={props.onBlur}
         value={props.isDisabled && props.isValueHiddenWhenDisabled ? '' : props.value}
         disabled={props.isDisabled}
         className={props.className}
      />
   );
};

TextInput.propTypes = {
   name: PropTypes.string.isRequired,
   value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   handleChange: PropTypes.func.isRequired,
   onBlur: PropTypes.func.isRequired,
   isDisabled: PropTypes.bool,
   isValueHiddenWhenDisabled: PropTypes.bool,
   className: PropTypes.string,
   type: PropTypes.string,
};

TextInput.defaultProps = {
   value: '',
   isDisabled: false,
   isValueHiddenWhenDisabled: false,
   className: '',
   type: 'text',
};

export default withUseEffectErrorMessage(withTextInput(withInputErrorMessage(TextInput)));
